import { render, staticRenderFns } from "./AdminBundleCoupons.vue?vue&type=template&id=40c5a4d6&"
import script from "./AdminBundleCoupons.vue?vue&type=script&lang=js&"
export * from "./AdminBundleCoupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40c5a4d6')) {
      api.createRecord('40c5a4d6', component.options)
    } else {
      api.reload('40c5a4d6', component.options)
    }
    module.hot.accept("./AdminBundleCoupons.vue?vue&type=template&id=40c5a4d6&", function () {
      api.rerender('40c5a4d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminBundleCoupons.vue"
export default component.exports